module.exports = __webpack_public_path__ + "6f423af00f726f2b5e8791b23cb7880b.jpg";